<template>
  <div class="card-boutique">
    <div class="card-block card-boutique__title">
      <h2 class="title">{{boutiqueInfo.name}}</h2>
    </div>
    <div class="card-block card-boutique__description">
      <div class="street-name">
        <span class="text">{{currentAddress}}</span>
      </div>
    </div>
    <div class="card-block card-boutique__content">
      <div class="store-info-column">
        <div class="store-info-column-col" v-if="boutiqueInfo.phone">
          <edit-value
          :scopedValue="boutiqueInfo.phone"
          :editMode="editBoutique"
          name="edit-phone"
          mageCallIdentifier="phone_number"
          :inputValidation="'required|phoneNumber'"
          classInput="rounded"
          @submitValue="submitGenericValue">
            <template slot="read-mode" slot-scope="opt">
              <a :href="`telto:${opt.value}`" type="button" class="bcm-link bcm-link-none btn btn-primary btn-primary-with-icon btn-rounded btn-primary-small btn-primary-black contact-button">
                <span class="text">{{opt.value}}</span>
                <svg class="o-icon fill-white"><use xlink:href="#telephone-outbound"></use></svg>
              </a>
            </template>
          </edit-value>
        </div>
        <div class="store-info-column-col" v-if="boutiqueInfo.email">
          <edit-value
          :scopedValue="boutiqueInfo.email"
          :editMode="editBoutique"
          name="edit-email"
          mageCallIdentifier="email"
          :inputValidation="'required|email'"
          classInput="rounded"
          @submitValue="submitGenericValue">
            <template slot="read-mode" slot-scope="opt">
              <a :href="`mailto:${opt.value}`" class="bcm-link bcm-link-none btn btn-secondary btn-secondary-with-icon btn-rounded btn-primary-small contact-button">
                <span class="text">{{opt.value}}</span>
                <svg class="o-icon"><use xlink:href="#email-outline"></use></svg>
              </a>
            </template>
          </edit-value>
        </div>
      </div>
      <div class="store-info-accordion">
        <working-hours
        :workingHours="boutiqueInfo.working_hours"
        :viewWorkingHours="viewWorkingHours"
        :editMode="editBoutique"
        @updateWorkingHours="submitWorkingHours"
        >
        </working-hours>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import WorkingHours from 'theme/components/StoreLocator/WorkingHours'
import BaseInput from 'theme/components/Form/BaseInput'
import BaseCheckBox from 'theme/components/Form/BaseCheckBox'
import BaseSelect from 'theme/components/Form/BaseSelect'
import EditValue from 'theme/components/StoreLocator/EditValue'

export default {
  name: 'CardBoutique',
  props: {
    boutiqueInfo: {
      type: Object | Array,
      required: true
    },
    viewImage: {
      type: Boolean,
      default: true
    },
    viewDetail: {
      type: Boolean,
      default: true
    },
    viewMap: {
      type: Boolean,
      default: true
    },
    viewWorkingHours: {
      type: Boolean,
      default: false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      editBoutique: false
    }
  },
  computed: {
    currentAddress () {
      return `${this.boutiqueInfo.address}, ${this.boutiqueInfo.city}, ${this.boutiqueInfo.region} – ${this.boutiqueInfo.country}`
    }
  },
  methods: {
    editMode (payload) {
      this.editBoutique = payload
    },
    submitWorkingHours ($event) {
      this.$emit('update-store', $event)
    },
    submitGenericValue ($event) {
      // Compose query parameters
      this.$emit('update-store', { data: { data: { [$event.dataIdentifier]: $event.value } } })
    }
  },
  mounted () {
    EventBus.$on('boutique:editMode', this.editMode)
  },
  destoyed () {
    EventBus.$off('boutique:editMode', this.editMode)
  },
  components: {
    BaseInput,
    BaseCheckBox,
    BaseSelect,
    EditValue,
    WorkingHours
  }
}
</script>
